import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import styles from "../styles/layouts/aboutUsCompany.module.css";

import imagem1 from "../assets/img-equipe1.png";
import imagem2 from "../assets/img-equipe2.png";
import imagem3 from "../assets/img-equipe3.png";
import imagem4 from "../assets/img-equipe4.png";
import imagem5 from "../assets/img-equipe5.png";
import imagem6 from "../assets/img-equipe6.png";
import imagem7 from "../assets/img-equipe7.png";
import imagem8 from "../assets/img-equipe8.png";
import imagem9 from "../assets/img-equipe9.png";
import imagem10 from "../assets/img-equipe10.png";
import imagem11 from "../assets/img-equipe11.png";
import imagem12 from "../assets/img-equipe12.png";
import imagem13 from "../assets/img-equipe13.png";
import imagem14 from "../assets/img-equipe14.png";
import imagem15 from "../assets/img-equipe15.png";
import imagem16 from "../assets/img-equipe16.png";
import imagem17 from "../assets/img-equipe17.png";
import imagem18 from "../assets/img-equipe18.png";
import imagem19 from "../assets/img-equipe19.png";

// Setas personalizadas (opcional)
const NextArrow = ({ onClick }) => (
  <div className={styles.custom_next_arrow} onClick={onClick}></div>
);

const PrevArrow = ({ onClick }) => (
  <div className={styles.custom_prev_arrow} onClick={onClick}></div>
);

const AboutUsCompany = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const images = [
    imagem1,
    imagem2,
    imagem3,
    imagem4,
    imagem5,
    imagem6,
    imagem7,
    imagem8,
    imagem9,
    imagem10,
    imagem11,
    imagem12,
    imagem13,
    imagem14,
    imagem15,
    imagem16,
    imagem17,
    imagem18,
    imagem19,
  ];

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "0",
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
    cssEase: "linear",
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1, centerMode: false },
      },
    ],
  };

  return (
    <section className={styles.success_services_section}>
      <div className={styles.section_header}>
        <h1>Conheça Nossa Equipe</h1>
      </div>

      <div className={styles.image_container}>
        <Slider {...settings}>
          {images.map((img, index) => (
            <div
              key={index}
              className={styles.slide}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <div
                className={`${styles.image_frame} ${
                  hoveredIndex !== null && hoveredIndex !== index
                    ? styles.blur
                    : ""
                }`}
              >
                <img
                  src={img}
                  alt={`Membro ${index + 1}`}
                  className={`${styles.about_image} ${
                    hoveredIndex === index ? styles.lift : ""
                  }`}
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>

      <div className={styles.about_content}>
        <h2>Nossa História</h2>
        <p>
          A Linked é a Empresa Júnior do curso de Ciência da Computação da
          Universidade Federal de São João del-Rei. Criada e gerida por
          estudantes, nossa missão é oferecer soluções tecnológicas inovadoras,
          garantindo qualidade e satisfação ao cliente.
        </p>
        <p>
          Valorizamos a inovação e o acolhimento, direcionando nossos lucros
          para criar oportunidades tanto para nossos membros quanto para a
          comunidade da computação. Compartilhamos nosso conhecimento para
          democratizar o acesso ao mercado de tecnologia, trabalhando para
          construir um ambiente colaborativo e acessível a todos.
        </p>
      </div>
    </section>
  );
};

export default AboutUsCompany;
